import React from 'react'
import { ToastContainer } from 'react-toastify'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import MainRouter from './MainRouter'
import theme from './utils/theme'
import 'react-toastify/dist/ReactToastify.css'

const AppProviders = (): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer />
      <MainRouter />
    </ThemeProvider>
  )
}

export default AppProviders